import { SizeIcon } from '@radix-ui/react-icons';

import { LabelWithoutRef } from '../../../../label/label-without-ref';
import { SelectModel } from '../../../../select/select-model';

import { InputNumberWithSteps } from '../controls/input-number-with-steps';
import type { AvatarShape } from './constants';

import { cn } from '../../../../../utils/cn';
import { AVATAR_SHAPE_MODEL } from './constants';

const IMAGE_MIN_SIZE = 16;
const IMAGE_MAX_SIZE = 370;
const IMAGE_SIZE_STEPS = [IMAGE_MIN_SIZE, 32, 64, 128, 192, 256, 320, IMAGE_MAX_SIZE];

type AppearanceProps = {
  className?: string;
  shape?: AvatarShape;
  size?: string;
  onShapeChange?: (shape: AvatarShape) => void;
  onSizeChange?: (size: string) => void;
};

export function Appearance({
  className,
  shape,
  size,
  onShapeChange,
  onSizeChange,
}: AppearanceProps) {
  return (
    <div className={cn('space-y-2', className)}>
      <p className="text-xs font-medium">Apariencia</p>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1">
        <div>
          <div className="flex items-center gap-1">
            <SizeIcon className="size-4" />
            <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
              Tamaño
            </LabelWithoutRef>
          </div>
          <InputNumberWithSteps
            id="appearance-avatar-size"
            max={IMAGE_MAX_SIZE}
            min={IMAGE_MIN_SIZE}
            steps={IMAGE_SIZE_STEPS}
            value={size === '' || size === undefined ? null : Number(size)}
            onChange={(value) => onSizeChange?.(value === null ? '' : String(value))}
          />
        </div>
        <div>
          <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
            Estilo
          </LabelWithoutRef>
          <SelectModel
            model={AVATAR_SHAPE_MODEL}
            size="sm"
            value={shape}
            variant="outline"
            onValueChange={(value) => onShapeChange?.(value as AvatarShape)}
          />
        </div>
      </div>
    </div>
  );
}
